var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-10 my-2"},[_c('h2',{staticClass:"my-4 text-4xl font-semibold"},[_vm._v("Upgrade")]),_c('button',{staticClass:"lb-admin-secondary-button-large mt-5",on:{"click":_vm.applyUpgrade}},[_vm._v(" Do Upgrade ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }